import './Chevron.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

export interface ChevronProps {
  /** When true the chevron points down (rotated 90° from its resting right-pointing state). */
  readonly expanded: boolean;
  readonly className?: string;
  /**
   * When provided, the chevron becomes a clickable expand/collapse control: a
   * bare button carrying the Collapse/Expand aria-label that stops click
   * propagation, so toggling never also triggers a row-level select. When
   * omitted it renders as a plain (decorative) icon.
   */
  readonly onToggle?: () => void;
}

/** Expand/collapse indicator: a single chevron that rotates 90° clockwise when expanded. */
export const Chevron = ({ expanded, className, onToggle }: ChevronProps) => {
  const iconClassName = `chevron${expanded ? ' chevron-expanded' : ''}`;

  if (!onToggle) {
    return <FontAwesomeIcon icon={faChevronRight} className={`${iconClassName}${className ? ` ${className}` : ''}`} />;
  }

  return (
    <button
      type="button"
      className={`chevron-toggle${className ? ` ${className}` : ''}`}
      aria-label={expanded ? 'Collapse' : 'Expand'}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      <FontAwesomeIcon icon={faChevronRight} className={iconClassName} />
    </button>
  );
};

export default Chevron;
